import React, { Component } from 'react'

class HeroSection extends Component {
    render() {
        var splashShown = sessionStorage.getItem('doday_splash_shown');
        var d = splashShown ? 0.1 : 2.6;

        return (
            <section className="hero">
                {/* Full-bleed food photography background */}
                <div className="hero_bg">
                    <img
                        src={process.env.PUBLIC_URL + "/image/cover.jpg"}
                        alt="豆日子招牌豆花"
                    />
                </div>

                {/* Warm gradient overlay */}
                <div className="hero_overlay"></div>

                {/* Text content */}
                <div className="hero_content">
                    <p className="hero_tagline_top" style={{ animationDelay: d + 's' }}>
                        Since 2020 &middot; Taipei
                    </p>
                    <h1 className="hero_title" style={{ animationDelay: (d + 0.1) + 's' }}>
                        DoDay 豆日子
                    </h1>
                    <p className="hero_descriptor" style={{ animationDelay: (d + 0.25) + 's' }}>
                        豆花甜品店
                    </p>
                    <p className="hero_subtitle" style={{ animationDelay: (d + 0.35) + 's' }}>
                        好日子，壞日子，都有豆日子
                    </p>
                    <div className="hero_cta_group" style={{ animationDelay: (d + 0.5) + 's' }}>
                        <a href="/order" className="hero_cta hero_cta_primary">
                            立刻訂購
                        </a>
                        <a href="/menu" className="hero_cta hero_cta_secondary">
                            查看菜單
                        </a>
                    </div>
                </div>

                {/* Scroll indicator */}
                <div className="hero_scroll_indicator" style={{ animationDelay: (d + 1.2) + 's' }}>
                    <span>Scroll</span>
                    <div className="hero_scroll_chevron"></div>
                </div>
            </section>
        );
    }
}

export default HeroSection;
